import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { CardPursePatchPayload } from '../ManageAccountAccessModal.types';

import { GET_CARD_PURSES_FOR_ACCESS_KEY } from './useGetCardPurses.query';

interface PatchCardPursesArgs {
  cardPurses: CardPursePatchPayload[];
  employeeId?: string | number;
}

interface Props {
  onError?: () => void;
}

const patchCardPurses = ({ cardPurses }: PatchCardPursesArgs) =>
  api.patch(API_URL.CARD_PURSES, {
    purses: cardPurses,
  });

export const usePatchCardPurses = ({ onError }: Props = {}) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation(patchCardPurses, {
    onSuccess: (_, { employeeId }) => {
      queryClient.invalidateQueries({
        queryKey: [GET_CARD_PURSES_FOR_ACCESS_KEY, employeeId],
        refetchType: 'none',
      });
    },
    onError: () => {
      onError?.();
    },
  });

  return {
    patchCardPurses: mutateAsync,
    isPending,
  };
};
